import React from 'react';
import { Typography, Box, Card, Grid, Link } from '@mui/material';
import {
  HelpOutline as HelpIcon,
  Description as DocsIcon,
  Support as SupportIcon,
} from '@mui/icons-material';
import { getDocsUrl } from '../../../utils/docsUrl';

interface ResourcesWidgetProps {
  showFAQ?: boolean;
}

/**
 * Resources & Support widget for dashboard
 * Displays help resources including FAQ, documentation, and support links
 */
export const ResourcesWidget: React.FC<ResourcesWidgetProps> = ({ showFAQ = true }) => {
  return (
    <Box sx={{ mb: 4 }}>
      <Typography variant="h6" sx={{ fontWeight: 600, mb: 3, mt: 16, textAlign: 'center' }}>
        Resources & Support
      </Typography>
      <Grid container spacing={2} alignItems="center" justifyContent="center">
        {showFAQ && (
          <Grid item xs={12} sm={6} md={3}>
            <Link href="#" sx={{ textDecoration: 'none' }}>
              <Card
                elevation={0}
                sx={(theme) => ({
                  p: 2,
                  textAlign: 'center',
                  cursor: 'pointer',
                  backgroundColor:
                    theme.palette.mode === 'light' ? '#ffffff' : theme.palette.background.paper,
                  border: '1px solid',
                  borderColor: 'divider',
                  boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.012), 0px 2px 8px rgba(0, 0, 0, 0.012)',
                  '&:hover': {
                    boxShadow:
                      '0px 6px 24px rgba(0, 0, 0, 0.018), 0px 3px 10px rgba(0, 0, 0, 0.018)',
                  },
                })}
              >
                <HelpIcon color="primary" sx={{ fontSize: 32, mb: 1 }} />
                <Typography variant="body2" sx={{ fontWeight: 500 }}>
                  FAQ
                </Typography>
              </Card>
            </Link>
          </Grid>
        )}

        <Grid item xs={12} sm={6} md={3}>
          <Link
            href={getDocsUrl()}
            target="_blank"
            rel="noopener noreferrer"
            sx={{ textDecoration: 'none' }}
          >
            <Card
              elevation={0}
              sx={(theme) => ({
                p: 2,
                textAlign: 'center',
                cursor: 'pointer',
                backgroundColor:
                  theme.palette.mode === 'light' ? '#ffffff' : theme.palette.background.paper,
                border: '1px solid',
                borderColor: 'divider',
                boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.012), 0px 2px 8px rgba(0, 0, 0, 0.012)',
                '&:hover': {
                  boxShadow: '0px 6px 24px rgba(0, 0, 0, 0.018), 0px 3px 10px rgba(0, 0, 0, 0.018)',
                },
              })}
            >
              <DocsIcon color="primary" sx={{ fontSize: 32, mb: 1 }} />
              <Typography variant="body2" sx={{ fontWeight: 500 }}>
                User Guide
              </Typography>
            </Card>
          </Link>
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <Link href="#" sx={{ textDecoration: 'none' }}>
            <Card
              elevation={0}
              sx={(theme) => ({
                p: 2,
                textAlign: 'center',
                cursor: 'pointer',
                backgroundColor:
                  theme.palette.mode === 'light' ? '#ffffff' : theme.palette.background.paper,
                border: '1px solid',
                borderColor: 'divider',
                boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.012), 0px 2px 8px rgba(0, 0, 0, 0.012)',
                '&:hover': {
                  boxShadow: '0px 6px 24px rgba(0, 0, 0, 0.018), 0px 3px 10px rgba(0, 0, 0, 0.018)',
                },
              })}
            >
              <SupportIcon color="primary" sx={{ fontSize: 32, mb: 1 }} />
              <Typography variant="body2" sx={{ fontWeight: 500 }}>
                Contact Support
              </Typography>
            </Card>
          </Link>
        </Grid>
      </Grid>
    </Box>
  );
};
